import { useEffect, useState } from "react";

import { useNavigate } from "@Libs/Router/hooks/useNavigate";

import { serviceRequestPathFragment } from "../../config/routes";
import { AUTH_SCREEN_KEYS } from "../config/constants";
import { IAuthIdentity, getAuthIdentity } from "./useAuthIdentity";

/**
 * The address the email screen resolved, or a redirect back to it — a pasted
 * URL reaches these screens with nothing to log in. Callers render nothing
 * while it is `undefined`.
 */
export const useRequireAuthIdentity = (): IAuthIdentity | undefined => {
  const navigate = useNavigate();
  // Once per mount: the email screen writes it before it navigates here.
  const [identity] = useState(getAuthIdentity);

  useEffect(() => {
    if (!identity)
      navigate(serviceRequestPathFragment.SERVICE_REQUEST_CREATION_SCREEN, {
        withLocale: true,
        params: { screenKey: AUTH_SCREEN_KEYS.EMAIL },
        // They were never really here, so Back must not return to it.
        replace: true,
      });
  }, [identity]);

  return identity;
};
